import Logger from "./logger";
import { getIn } from "../frontendlib/utils";

const initialScreenAngle = getIn(window, ["screen", "orientation", "angle"]);

const RESIZE_LOGGING_SAMPLING_FREQUENCY_MULTIPLIER = 0.1;

/**
 * Logs window resize events to Adexp.
 */
class WindowResizeLogger {
  constructor(snippetEl, enable_logging) {
    // We log resizes at a lower sampling frequency, because the log messages can be very numerous.
    this.enableResizeLogging = enable_logging
      ? Math.random() < RESIZE_LOGGING_SAMPLING_FREQUENCY_MULTIPLIER
      : false;

    this.resizeCount = 0;
    this.resizeLog = [];
    this.snippetEl = snippetEl;

    window.addEventListener("resize", () => {
      this.logResizedDims();
    });
  }

  _logDims() {
    if (!this.enableResizeLogging) return;
    const { width, height } = this.snippetEl.getBoundingClientRect();
    const data = {
      height,
      width,
      sinceStartMS: Date.now() - LIFTOFF_START_TS,
      "screen.orientation.angle": getIn(window, [
        "screen",
        "orientation",
        "angle",
      ]),
      initialScreenAngle,
      resizeCount: this.resizeCount,
      // Check support of rotation events.
      supportsOrientationChange: "onorientationchange" in window,
      supportsDeviceOrientation: "ondeviceorientation" in window,
      "window.innerWidth": window.innerWidth,
      "window.innerHeight": window.innerHeight,
      "documentElement.clientWidth":
        document.documentElement != null &&
        document.documentElement.clientWidth,
      "documentElement.clientHeight":
        document.documentElement != null &&
        document.documentElement.clientHeight,
    };
    this.resizeLog = [...this.resizeLog, data];
    Logger.recordLog("resize", "resize", { resizeLog: this.resizeLog });
  }

  logInitialDims() {
    this._logDims();
  }

  logResizedDims() {
    this.resizeCount += 1;
    this._logDims();
  }
}

export default WindowResizeLogger;



// WEBPACK FOOTER //
// ./src/js/madlib/window_resize_logger.js